import React from 'react'
import { Herosection } from '../Component/Herosection'
import { Ourservice } from '../Component/Ourservice'
import { Blogs } from '../Component/Blogs'
import { ContactUs } from '../Component/ContactUs'

export const HomePage = () => {
  return (
    <div>
        <Herosection />
        <Ourservice />
        <Blogs/>
        <ContactUs/>
    </div>
  )
}
